import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Col,
  Container,
  Form,
  FormInput,
  FormTextarea,
  Row,
} from "shards-react";
import { HpButton } from "../HpButton/HpButton";
import API from "../Api/API";
import { handleErrorMessage } from "../ErrorMessages/ErrorMessages";
import HpModal from "../Modal/HpModal";
import { showNotification } from "../Notification/Notification";

const ContactForm = ({ primaryColor, open, toggle }) => {
  const { t } = useTranslation(["contact"]);

  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const response = await fetchUser();
      setUser(response);
    };
    getData();
  }, []);

  useEffect(() => {
    if (user) {
      setEmail(user.email);
    } else {
      setEmail("");
    }
  }, [user]);

  const fetchUser = () => {
    return axios
      .get(API.url + "api/user/details", { withCredentials: true })
      .then((res) => res.data)
      .catch((err) => handleErrorMessage(err.response.status));
  };

  const close = () => {
    setSubject("");
    setMessage("");
    toggle();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDisabled(true);

    const payload = {
      subject,
      text: message,
      contactEmail: email,
      contactPhoneNumber: phone,
    };

    axios
      .post(API.url + "api/mail/support", payload, { withCredentials: true })
      .then(() => {
        close();
        setDisabled(false);
        showNotification(t("message_sent_successfully"));
      })
      .catch((error) => handleErrorMessage(error.response.status));
  };

  return (
    <HpModal
      open={open}
      toggle={close}
      title={t("support_text")}
      body={
        <Container>
          <Form onSubmit={handleSubmit} id="contact-form">
            <Row className="align_center popup_form_label_row">
              <Col lg={{ size: 10, offset: 1 }}>
                <label htmlFor="contact_email_input" className="form-label">
                  {t("your_email")}
                </label>
              </Col>
            </Row>
            <Row className="align_center popup_form_content_row">
              <Col lg={{ size: 10, offset: 1 }}>
                <FormInput
                  size="lg"
                  type="text"
                  id="contact_email_input"
                  value={email}
                  disabled
                  required
                />
              </Col>
            </Row>
            <Row className="align_center popup_form_label_row">
              <Col lg={{ size: 10, offset: 1 }}>
                <label htmlFor="contact_phone_input" className="form-label">
                  {t("your_phone_number")}
                </label>
              </Col>
            </Row>
            <Row className="align_center popup_form_content_row">
              <Col lg={{ size: 10, offset: 1 }}>
                <FormInput
                  size="lg"
                  type="text"
                  id="contact_phone_input"
                  value={phone}
                  placeholder={t("your_phone_number")}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row className="align_center popup_form_label_row mt-5">
              <Col lg={{ size: 10, offset: 1 }}>
                <label htmlFor="subject_input" className="form-label">
                  {t("subject")}
                </label>
              </Col>
            </Row>
            <Row className="align_center popup_form_content_row">
              <Col lg={{ size: 10, offset: 1 }}>
                <FormInput
                  size="lg"
                  type="text"
                  id="subject_input"
                  placeholder={t("subject")}
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col lg={{ size: 10, offset: 1 }}>
                <FormTextarea
                  id="support_message_input"
                  placeholder={t("message")}
                  style={{ minHeight: "86pt" }}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </Col>
            </Row>
          </Form>
        </Container>
      }
      actions={
        <HpButton
          form="contact-form"
          type="submit"
          size="lg"
          squared
          primaryColor={primaryColor}
          disabled={disabled}
        >
          {t("send")}
        </HpButton>
      }
    />
  );
};

export default ContactForm;
